import { render, staticRenderFns } from "./EditResultsInfo.vue?vue&type=template&id=ed7b15ce&scoped=true&lang=pug"
import script from "./EditResultsInfo.vue?vue&type=script&lang=js"
export * from "./EditResultsInfo.vue?vue&type=script&lang=js"
import style0 from "./EditResultsInfo.vue?vue&type=style&index=0&id=ed7b15ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7b15ce",
  null
  
)

export default component.exports